import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext({ user: null, loading: true, login: async () => {}, logout: async () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        // Cookie-based auth: the httpOnly access_token cookie is sent automatically
        // by axios (withCredentials: true). No localStorage access required.
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (err) {
        // Not authenticated — fine on public pages. Log only non-401 errors.
        if (err?.response?.status && err.response.status !== 401) {
          console.warn("[auth] /auth/me failed:", err.response.status, err.message);
        }
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    // Backend sets httpOnly access_token cookie (samesite=lax) — no token stored client-side.
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.warn("[auth] logout failed:", err?.message);
    }
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
